export enum OrderBy {
    Asc = 'asc',
    Desc = 'desc',
}
